import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import SettingsIcon from '@mui/icons-material/Settings';
import DeleteIcon from '@mui/icons-material/Delete';
import { Container, IconButton, ListItemButton, ListItemText } from '@mui/material';
import List from '@mui/material/List';
import ListItemIcon from '@mui/material/ListItemIcon';
import * as React from 'react';
import PropTypes from 'prop-types';

export default function ListItemWithIcon({
  list,
  level,
  onChange,
  onAction,
  onDelete,
  isNotShowIcon,
  selectedIndex,
  disabledItems,
  singleSelectionMode
}) {

  const handleClick = (value, level, index) => {
    if (value?.isAction) {
      return; // Skip if it is an action item
    }
    onChange(value, level, index);
  };

  return (
    <Container sx={{
      display: 'flex',
      flex: '1 1 0%',
      flexDirection: 'column',
      padding: '0 !important',
      border: 'solid 1px #d5d8dd',
      maxHeight: '20rem',
      overflowY: 'scroll',
      overflowX: 'hidden'
    }}
    >
      <List sx={{ width: '100%', padding: '0' }}>
        {list?.length > 0 &&
          list.map((value, index) => (
            <ListItemButton
              sx={{ display: 'flex', justifyContent: 'space-between', paddingRight: '4px' }}
              className="icon-list-item"
              key={index + value.label} // eslint-disable-line
              button
              selected={index === selectedIndex}
              disabled={singleSelectionMode || disabledItems.includes(value.key)}
              onClick={() => {
                handleClick(value, level, index);
              }}
            >
              <ListItemText primary={value.label} sx={{ margin: 0 }} />
              {value?.canRemove && onDelete && (
              <ListItemIcon
                sx={{ padding: 0 }}
                onClick={(event) => {
                  event.stopPropagation();
                  onDelete(value);
                }}
              >
                <IconButton size="medium">
                  <DeleteIcon color="primary" />
                </IconButton>
              </ListItemIcon>
              )}
              {!isNotShowIcon && (value.children?.length > 0) && (
                <ListItemIcon sx={{ padding: 0 }}>
                  <KeyboardArrowRightIcon sx={{ width: '1.5rem', height: '1.5rem' }} />
                </ListItemIcon>
              )}
              {onAction && value?.isAction && (
              <ListItemIcon
                sx={{ padding: 0 }}
                onClick={() => onAction(value, level, index)}
              >
                <IconButton size="medium">
                  <SettingsIcon
                    color="primary"
                  />
                </IconButton>
              </ListItemIcon>
              )}
            </ListItemButton>
          ))}
      </List>
    </Container>
  );
}

ListItemWithIcon.propTypes = {
  list: PropTypes.array.isRequired,
  level: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  isNotShowIcon: PropTypes.bool,
  selectedIndex: PropTypes.number,
  disabledItems: PropTypes.array,
  singleSelectionMode: PropTypes.bool,
  onAction: PropTypes.func,
  onDelete: PropTypes.func,
};

ListItemWithIcon.defaultProps = {
  isNotShowIcon: false,
  selectedIndex: null,
  disabledItems: [],
  singleSelectionMode: false,
};
